import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'

// Define a service using a base URL and expected endpoints
export const mgpApi = createApi({
        reducerPath: 'mgpApi',
        baseQuery: fetchBaseQuery({
            baseUrl: process.env.REACT_APP_API_URL,
        }),
    // refetchOnMountOrArgChange: 'always',
    tagTypes: ['Pages'],
    endpoints: (builder) => ({
            getPages: builder.query({
                query: () => `pages`,
                refetchOnMount: 'always',
                providesTags: ['Pages'],
            }),
            getPageSettings: builder.query({
                query: () => `page_settings`,
                refetchOnMount: 'always',
            }),
            getPagesDetail: builder.query({
                query: (id) => `page_detail/${id}`,
                refetchOnMount: 'always',
            }),
            getServiceDetail: builder.query({
                query: (id) => `home_service_detail/${id}`,
                refetchOnMount: 'always',
            }),
        }),
    })

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
    useGetPagesQuery,
    useGetPageSettingsQuery,
    useGetPagesDetailQuery,
    useGetServiceDetailQuery,
} = mgpApi